module.exports = __webpack_public_path__ + "static/media/icon-nareit.4e4e8d12.svg";